/**
 * Mobile (below `lg`) layout of the Environment section: the paragraph, the optional document
 * link, then the image full width. It renders no title: the page's accordion tab header shows it.
 *
 * Rendered by `./Environment.tsx` and, with the Ryerson Gives Back copy, by
 * `../../RyersonGivesBackPage/Volunteering/Volunteering.tsx`. Desktop counterpart:
 * `./EnvironmentDesktop.tsx`.
 */
import { ContentSection } from "@ryerson/frontend.layout";
import { Typography } from "@ryerson/frontend.typography";
import styled from "@emotion/styled";
import React from "react";
import { EnvProps } from "./Environment";
import { Link } from "@ryerson/frontend.navigation";
import { css } from "@emotion/react";

const MobileImageContainer = styled.img`
	margin-top: 22px;
	width: 100%;
	min-height: 180px;
`;

/**
 * Renders the section below `lg`. The document link uses `next={false}`, a plain `<a>`, as in
 * `./EnvironmentDesktop.tsx`.
 */
const EnvironmentMobile: React.FC<EnvProps> = ({ ...props }) => {
	const background = props?.background || "primary";
	return (
		<ContentSection type={background} hPadding="0">
			<Typography size="md" variant="p">
				{props?.content}
			</Typography>
			{props?.fileUrl ? (
				<Link
					type="primary"
					to={props.fileUrl}
					css={css`
						margin-top: 10px;
					`}
					next={false}
				>
					{props.fileUrlLabel}
				</Link>
			) : (
				<></>
			)}
			<MobileImageContainer src={props?.imageUrl} alt={props?.title} />
		</ContentSection>
	);
};

export default EnvironmentMobile;
